import React from 'react';
import OptImage from '../utils/OptImage';

const Services = ({ onProcedureClick }) => {
  const services = [
    {
      id: 1,
      title: "Facial Rejuvenation",
      description: "Advanced facial procedures for natural-looking rejuvenation",
      image: "facial-rejuvenation_uq8z5p",
      subtitle: "Bring balance and proportion to your face"
    },
    {
      id: 2,
      title: "Body Contouring",
      description: "Sculpt and reshape your body with precision techniques",
      image: "body-contouring_zrcnb6",
      subtitle: "Sculpt and reshape your body contours"
    },
    {
      id: 3,
      title: "Hair Restoration",
      description: "Restore confidence with natural hair growth solutions",
      image: "hair-restoration_nnqlpd",
      subtitle: "Restore your natural hair growth"
    },
    {
      id: 4,
      title: "Breast Enhancement",
      description: "Enhancement and reconstruction with natural results",
      image: "breast-measurement_ohdqw6",
      subtitle: "Enhance and reshape your natural beauty"
    },
    {
      id: 5,
      title: "Laser Treatments",
      description: "Advanced laser solutions for skin perfection",
      image: "laser-treatments_vpzoss",
      subtitle: "US FDA approved laser treatments"
    },
    {
      id: 6,
      title: "Anti-Aging",
      description: "Turn back time with cutting-edge anti-aging treatments",
      image: "anti-aging_ztyg8c",
      subtitle: "Turn back the clock with our treatments"
    },
    {
      id: 7,
      title: "Facial Contouring",
      description: "Enhance your facial features with cosmetic surgery",
      image: "facial-contouring_x6yjyb",
      subtitle: "Define and enhance your facial structure"
    },
    {
      id: 8,
      title: "Vitiligo and Color Correction",
      description: "Comprehensive vitiligo treatments for effective color restoration",
      image: "vitiligo-symptoms_qvwegq",
      subtitle: "Effective vitiligo and color correction treatments"
    },
    {
        id: 9,
        title: "Female aesthetic surgeries",
        description: "Specialized aesthetic surgeries tailored for women",
        image: "vaginal-treatment_wjlqki",
        subtitle: "Enhance your feminine confidence"
      }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="services-header">
          <h1 className="section-title">Cosmetic & Plastic Surgery Services in Bhopal</h1>
          <h2 className="section-subtitle">Our Specialized Treatments & Procedures</h2>
          <p className="services-subtitle">Explore our comprehensive range of aesthetic procedures designed to enhance your natural beauty</p>
        </div>
        <div className="services-grid">
          {services.map(service => (
            <div 
              key={service.id} 
              className="service-tile"
              onClick={() => onProcedureClick(service)}
            >
              <div className="service-background">
                <OptImage src={service.image} alt={`Service: ${service.title} in Bhopal`} />
                <span className="image-attribution">Image by Freepik</span>
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-subtitle">{service.subtitle}</p>
              </div>
              <div className="service-overlay"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;